<template>
  <dara-invisible>
    <dara-row class="mb--md d-flex justify-content-center justify-content--space-between align-items-center">
      <dara-col :xs="24" :span="showRangeDate ? 12 : 24" class="mb--sm mt--xl">
        <dara-header size="md">
          {{ label }} <dara-small v-if="!showRangeDate && type == 'track'">({{ $t('all-period') }})</dara-small>
        </dara-header>
      </dara-col>

      <dara-col v-if="showRangeDate" :xs="24" :span="13" class="mb--sm mt--xl d-flex justify-content-center">
        <dara-invisible class="ml--lg d-flex justify-content-center align-items-center">
          <dara-p class="mr--md mb--0 mt--md">{{ $t('from') }}</dara-p>
          <dara-input
            v-model="startDate"
            type="date"
            :name="$t('begin-date')"
            rules=""
            @change="fetch()" />
        </dara-invisible>
        <dara-invisible class="ml--lg d-flex justify-content-center align-items-center">
          <dara-p class="mr--md mb--0 mt--md ">{{ $t('to') }}</dara-p>
          <dara-input
            v-model="endDate"
            type="date"
            :name="$t('end-date')"
            rules=""
            @change="fetch()" />
        </dara-invisible>

        <div class="cursor--pointer ml--lg gray-squared-button d-flex justify-content-center align-items-center" name="download" @click="downloadCSV">
          <el-tooltip effect="dark" :content="$t('download-csv')" placement="top">
            <i class="el-icon-download" />
          </el-tooltip>
        </div>
      </dara-col>
    </dara-row>
  </dara-invisible>
</template>

<script>
import { toastError } from '@/services/toastService';
import { translate } from '@/services/translate.service';
import { getMonthRange } from '@/services/timeService';

export default {
  name: 'DaraTableLabel',
  props: {
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    showRangeDate: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      date: new Date(),
      startDate: '',
      endDate: '',
    };
  },
  created() {
    this.buildRangeDate();
  },
  methods: {
    fetch() {
      if (this.startDate >= this.endDate) {
        toastError(translate('error-start-date-greater-then-end-date'));
        return;
      }
      this.$emit('fetch', [this.startDate, this.endDate]);
    },
    downloadCSV() {
      if (this.startDate >= this.endDate) {
        toastError(translate('error-start-date-greater-then-end-date'));
        return;
      }
      this.$emit('download', [this.startDate, this.endDate]);
    },
    buildRangeDate() {
      const { start, end } = getMonthRange();
      this.startDate = start;
      this.endDate = end;
    },
  },
};
</script>

<style scoped>
  .gray-squared-button {
    height: 2.6rem;
    width: 2.6rem;
    border-radius: 5px;
    color: rgb(161, 161, 161);
    background-color: #f4f4f5 !important;
  }
  .gray-squared-button:hover {
    background-color: #f0f0f0 !important;
  }
</style>
